<template>
<StdPageContainer type="list">
  <template slot="title">
    <!-- NOTE: 标题栏: 开发人员根据业务调整 -->
    <StdPageTitle :title="$t('lang.k_215001')">
      <p class="title_tips">
        {{ $t('lang.k_215002') }}
        <a href="https://saas-doc.vhall.com/opendocs/show/1782" target="_blank" class="link">
          {{ $t('lang.k_215003') }}
        </a>
      </p>
    </StdPageTitle>
  </template>

  <!-- 内容区 -->
  <template slot="content">
    <!-- 这块内容在 无Tab 和 有tab 页面都使用，所有单独抽离-->
    <AwardList style="min-height: 600px" />
  </template>
</StdPageContainer>
</template>

<script>

import { AwardList } from '@vhcl/mall-rewards';
export default {
  components: {
    AwardList
  },
  methods: {
    handleSearch() {}
  }
};
</script>
<style lang="less" scoped>
  .title_tips {
    font-size: 14px;
    color: #999;
    margin-left: 10px;
  }
</style>
